import React, { useState, useContext } from 'react';
import { signInWithCustomToken } from 'firebase/auth';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { getAuth } from 'firebase/auth';
import { useTranslation } from 'react-i18next';
import ContentApp from '../../../components/ContentApp';
import ButtonProccessing from '../../../components/Common/ButtonProccessing/ButtonProccessing';
import useForm from '../../../helpers/useForm';
import Header from '../../../components/Common/Header/Header';
import { WelletContext } from '../../../context/WelletContext';
import { exchangeToken } from '../../../actions/associatesActions';
import ErrorBox from '../../../components/Common/ErrorBox/ErrorBox';
import InputFormBorder from '../../../components/Common/InputFormBorder/InputFormBorder';
import { createUser } from '../../../services/user/userService';
import { useLocation } from 'react-router-dom/cjs/react-router-dom';
import { getQueryString } from '../../../helpers/url';

const SignUpCreateUser = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const tenant = useSelector((state) => state.app.tenantId);
  const language = useSelector((state) => state.app.language);
  const auth = getAuth();
  auth.tenantId = tenant;

  const firstName = searchParams.get('firstName');
  const lastName = searchParams.get('lastName');
  const email = searchParams.get('email');
  const stateId = searchParams.get('stateId');
  const phone = getQueryString('phone');
  const activityId = parseInt(searchParams.get('activityId'));
  const jobTitle = searchParams.get('role');
  const company = searchParams.get('company');
  const rpId = searchParams.get('rpId');
  const cityId = searchParams.get('cityId');
  const countryCode = searchParams.get('countryCode');
  const userCountryCode = searchParams.get('userCountryCode');
  const city = searchParams.get('city');
  const postalCode = searchParams.get('postalCode');
  const address = searchParams.get('address');
  const token = searchParams.get('token');

  const welletContext = useContext(WelletContext);
  const [error, setError] = useState(null);
  const [buttonStatus, setButtonStatus] = useState('NORMAL');

  const onContinueHandle = (user) => {
    exchangeToken(dispatch, user, () => history.push('/'));
  };

  function validate(values) {
    let errors = {};
    const rexCapital = /[A-Z]/;
    const rexNumber = /[0-9]/;
    const rexSpace = /\s/;
    if (!values.password) {
      errors.password = t('passwordError.PASSWORD_TOO_SHORT');
    } else if (values.password.length < 8) {
      errors.password = t('passwordError.PASSWORD_TOO_SHORT');
    } else if (!rexCapital.test(values.password)) {
      errors.password = t('passwordError.PASSWORD_HAS_NOT_UPPERCASE_LETTER');
    } else if (!rexNumber.test(values.password)) {
      errors.password = t('passwordError.PASSWORD_HAS_NOT_NUMBER');
    } else if (rexSpace.test(values.password)) {
      errors.password = t('passwordError.PASSWORD_CONTAIN_SPACES');
    } else if (values.password !== values.passwordconfirmation) {
      errors.passwordconfirmation = t('passwordError.PASSWORD_NOT_MATCH');
    }
    return errors;
  }

  const sendForm = async () => {
    setButtonStatus('INPROGRESS');
    setError(null);
    try {
      const result = await createUser(
        firstName,
        lastName,
        values.password,
        tenant,
        email,
        countryCode,
        userCountryCode,
        stateId,
        city,
        postalCode,
        address,
        phone,
        activityId,
        jobTitle,
        company,
        rpId === '0' ? null : rpId,
        cityId === 'null' ? null : cityId,
        language,
        token,
        welletContext,
      );
      if (result.data.verification) {
        setButtonStatus('FINISHED');
        const userCredentials = await signInWithCustomToken(auth, result.data.token);
        onContinueHandle(userCredentials.user);
      } else {
        setButtonStatus('NORMAL');
        setError('x');
      }
    } catch (error) {
      setButtonStatus('NORMAL');
      setError('x');
      console.error(error);
    }
  };

  const { values, errors, handleChange, handleSubmit } = useForm(sendForm, validate);

  return (
    <>
      <Header title={''} hasBackground={true} />
      <ContentApp background={true}>
        <div>
          <div className='text-left'>
            <div className='font-medium mt-3 bold' style={{ color: '#fff' }}>
              {t('signUp.choosePassword')}
            </div>
            <div className='mt-2 subtitle font-small' style={{ color: 'var(--color-font-gray)' }}>
              {t('signUp.passwordDescription')}
            </div>
          </div>
          <form className='mt-4' onSubmit={handleSubmit}>
            <div className='mt-4'>
              <InputFormBorder
                name='password'
                type='password'
                value={values.password}
                error={errors.password}
                placeholder={t('password')}
                onChange={handleChange}
              />
            </div>
            <div className='mt-4'>
              <InputFormBorder
                name={'passwordconfirmation'}
                type={'password'}
                value={values.passwordconfirmation}
                error={errors.passwordconfirmation}
                placeholder={t('repeatPassword')}
                onChange={handleChange}
              />
            </div>
            {error ? (
              <div className='mt-3'>
                <ErrorBox title='Error' description={t('passwordError.CHANGE_PASSWORD_TITLE')} />
              </div>
            ) : null}
            <div className='mt-3 d-flex justify-content-center'>
              <ButtonProccessing
                size={'large'}
                text={t('continue')}
                inProgressText='Procesando'
                status={buttonStatus}
                checkSize='30px'
                arrow={true}
                backgroundColor='var(--color-primary)'
                color='#000'
                iconColor='#000'
                className={'d-flex align-items-center justify-content-center'}
              />
            </div>
          </form>
        </div>
      </ContentApp>
    </>
  );
};

export default SignUpCreateUser;
